import * as React from "react";
import { DimensionCheckBoxState } from "../../dimension-types";
import { Card as BaseCard, ListItem } from "@material-ui/core";
import { merge, $ } from "glamor";
import { theme } from "styles/theme";
import classNames from "classnames";
import Checkbox from "material-ui/Checkbox";
import { DATATEST } from "constants/integration";
import { ChevronRight } from "@material-ui/icons";
import { Label, Text } from "@nuorder/components";
import { SelectedElementsMessage } from "../selected-elements-label";

type CardProps = {
    label: string;
    dimensionId: string;
    checkboxState: DimensionCheckBoxState;
    selected: boolean;
    selectDimensionHandler: () => void;
    onToggleSelect: () => void;
    dimensionValuesCount: number;
    selectedDimensionValuesCount: number;
};

export const DoorsTabCard = ({
    label,
    dimensionId,
    checkboxState,
    selected,
    selectDimensionHandler,
    onToggleSelect,
    dimensionValuesCount,
    selectedDimensionValuesCount,
}: CardProps) => {
    return (
        <BaseCard {...styles} className="dimensionsItem">
            <ListItem
                classes={{
                    gutters: "gutter",
                }}
                data-dimension={label}
            >
                <div
                    className={classNames("dimensionItemContainer", {
                        border: true,
                    })}
                    data-test={`${DATATEST.ASSORTMENTS.GROUPING.ATTRIBUTES.CONTAINER}-${dimensionId}`}
                >
                    <DimensionHeader>
                        <div className="dimensionTextContainer">
                            {checkboxState !== DimensionCheckBoxState.Hidden && (
                                <Checkbox
                                    checked={selected}
                                    onCheck={onToggleSelect}
                                    disabled={checkboxState === DimensionCheckBoxState.Disabled}
                                />
                            )}
                            <Text>{label}</Text>
                        </div>
                    </DimensionHeader>

                    <Label
                        className="dimensionsLabel"
                        style={{ fontWeight: "inherit" }}
                        onClick={selectDimensionHandler}
                    >
                        <SelectedElementsMessage
                            size={dimensionValuesCount}
                            selectedOptionsSize={selectedDimensionValuesCount}
                        />
                        <ChevronRight />
                    </Label>
                </div>
            </ListItem>
        </BaseCard>
    );
};

const DimensionHeader = ({ children }: { children: React.ReactNode }) => (
    <div className="dimensionHeader">{children}</div>
);

const styles = merge(
    {
        margin: "10px !important",
        opacity: "1",
    },
    $(" .gutter", {
        paddingLeft: "8px",
        paddingRight: "8px",
    }),
    $(" .dimensionItemContainer", {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    }),
    $(" .dimensionItemContainer.border", {
        borderBottom: `1px solid ${theme.palette.borderColor}`,
    }),
    $(" .dimensionsLabel", {
        display: "flex",
        width: "100%",
        marginTop: "6px",
        padding: "5px 6px",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer !important",
    }),
    $(" .dimensionHeader", {
        display: "flex",
        justifyContent: "space-between",
    }),
    $(" .dragHandler", {
        marginTop: "1px",
    }),
    $(" .dimensionTextContainer", {
        display: "flex",
        flexDirection: "row",
    }),
    $(" .dimensionSelector", {
        marginLeft: "6px",
        width: "100% !important",
        overflow: "hidden !important",
        display: "flex !important",
    }),
    $(" .dimensionSelector label", {
        width: "100% !important",
        zIndex: "10",
        cursor: "pointer",
    }),
    $(" .dimensionSelector .nameLabel", {
        maxWidth: "145px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        zIndex: "10",
        cursor: "pointer",
    }),
    $(" .dimensionSelector .subLabel", {
        display: "flex",
        flexDirection: "row",
        maxWidth: "100%",
    }),
    $(" .dimensionSelector .collectionDimensionCard", {
        display: "flex",
        flexDirection: "column",
        width: "100%",
    }),
    $(" .dimensionSelector .containerNameLabel", {
        display: "flex",
        flexDirection: "row",
        maxWidth: "100%",
        justifyContent: "space-between",
    }),
    $(" .dimensionSelector span", {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        maxWidth: "100%",
    }),
    $(" .dimensionSelector .subLabel .small", {
        maxWidth: "145px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontWeight: "400",
        fontSize: "10px",
    }),
    $(" .dimensionName", {
        marginLeft: "6px",
    }),
    $(" .attributeKaboButton > span", {
        alignItems: "flex-start !important",
    }),
    $(" .dimensionChip", {
        backgroundColor: theme.palette.blue,
        color: theme.palette.white,
        borderRadius: "5px",
        height: "20px",
        fontWeight: "700",
        marginLeft: "10px",
    }),
    $(" .dimensionChip > span", {
        padding: "5px !important",
    }),
    $(" .dimensionSelectorContainer", {
        display: "flex",
        width: "100%",
    })
);
